import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectHexes,
  selectPendingBuildings,
  selectSpecialBuildings,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {checkIfHexBlockedByEnemyUnit} from "../../gameState/checkIfHexBlockedByEnemyUnit";
import {COMMON_BUILDING_TOKENS, TOKENS} from "../../../constants/tokens";
import {HEX_DIRECTIONS} from "../../../constants/geometry";
import {coordsToKey} from "../../coords/coordsToKey";
import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";
import {checkIfBaseBuildingDamaged} from "../../gameState/checkIfBaseBuildingDamaged";

export const calculateAvailableConstructionCellsForMineExploration = (state) => {
  const currentPlayer = selectCurrentPlayer(state);
  const citiesCache = selectCitiesCache(state);
  const hexes = selectHexes(state);
  const units = selectUnits(state);
  const specialBuildings = selectSpecialBuildings(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const pendingBuildings = selectPendingBuildings(state);

  const playerCities = citiesCache[currentPlayer.color] || [];
  const candidateCells = new Set();

  // Собираем все валидные кварталы (уже размещенные + pending)
  const validQuarterKeys = [];
  const centralQuarters = new Set();

  // 1. Уже размещенные кварталы из citiesCache
  for (const city of playerCities) {
    validQuarterKeys.push(city.centralQuarter);
    centralQuarters.add(city.centralQuarter);

    const quarters = city[COMMON_BUILDING_TOKENS.QUARTER];
    if (quarters && Array.isArray(quarters)) {
      validQuarterKeys.push(...quarters);
    }
  }

  for (const action of pendingBuildings) {
    if (checkIfCentralQuarter(action.token)) {
      validQuarterKeys.push(action.hexKey);
      centralQuarters.add(action.hexKey);
    }
  }

  // 3. Базовые кварталы из pendingBuildings
  for (const action of pendingBuildings) {
    if (action.token !== TOKENS.QUARTER) {
      continue;
    }

    const [q, r] = action.hexKey.split(',').map(Number);
    let isAdjacentToCentral = false;

    for (const [dq, dr] of HEX_DIRECTIONS) {
      const adjKey = coordsToKey(q + dq, r + dr);
      // Квартал у поврежденного Центрального некорректен и будет снят при завершении
      // хода: разведка на него опираться не может (она фиксируется и не отменяется)
      if (centralQuarters.has(adjKey) && !checkIfBaseBuildingDamaged(adjKey, buildingsDamage, specialBuildings)) {
        isAdjacentToCentral = true;
        break;
      }
    }

    if (isAdjacentToCentral) {
      validQuarterKeys.push(action.hexKey);
    }
  }

  // 4. Ищем пустые ячейки, смежные валидным кварталам
  for (const quarterKey of validQuarterKeys) {
    const isQuarterBlocked = checkIfHexBlockedByEnemyUnit(
      quarterKey,
      null,
      currentPlayer.id,
      units,
      null,
      null,
      null
    );

    if (isQuarterBlocked) {
      continue;
    }

    const [q, r] = quarterKey.split(',').map(Number);

    for (const [dq, dr] of HEX_DIRECTIONS) {
      const adjQ = q + dq;
      const adjR = r + dr;
      const adjKey = coordsToKey(adjQ, adjR);

      const token = hexes[adjKey];
      if (token && token !== TOKENS.ROAD) {
        continue;
      }

      let isAdjacentToMine = false;
      for (const [mq, mr] of HEX_DIRECTIONS) {
        const mineCheckQ = adjQ + mq;
        const mineCheckR = adjR + mr;
        const mineCheckKey = coordsToKey(mineCheckQ, mineCheckR);
        const token = hexes[mineCheckKey];

        if (token === TOKENS.MINE || token === TOKENS.SUPER_MINE) {
          isAdjacentToMine = true;
          break;
        }
      }

      if (!isAdjacentToMine) {
        candidateCells.add(adjKey);
      }
    }
  }

  return Array.from(candidateCells).filter(hexKey => {
    return !checkIfHexBlockedByEnemyUnit(
      hexKey,
      TOKENS.MINE,
      currentPlayer.id,
      units,
      hexes,
      specialBuildings,
      buildingsDamage
    );
  });
};
